import { InterventionPreventive } from '@/models/InterventionPreventive';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';
import { MutationTree } from 'vuex';
import { SUIVI_INTERVENTION_PREVENTIVE } from './mutation-types';
import { initialState as resetState, SuiviInterventionPreventiveState } from './state';

export const mutations: MutationTree<SuiviInterventionPreventiveState> = {
    [SUIVI_INTERVENTION_PREVENTIVE.SET_ITEMS](state, items: InterventionPreventive[]) {
        state.interventions = items;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.RESET_ITEMS](state) {
        state.interventions = [];
        state.page = 0;
        state.count = 0;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.ADD_ITEMS](state, items: InterventionPreventive[]) {
        state.interventions = [...state.interventions, ...items];
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_NB_OF_PAGES](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_COUNT](state, count: number) {
        state.count = count;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return [...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_STATUS](state, statusList: Array<string>) {
        state.filterStatus = statusList;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_PREDICTED_DATE_FROM](state, value: string) {
        state.filterPredictedDateFrom = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_PREDICTED_DATE_TO](state, value: string) {
        state.filterPredictedDateTo = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_IS_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_ERROR](state, error: Error | undefined) {
        state.error = error;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.CLEAR_ALL](state) {
        Object.assign(state, resetState);
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_EXPORT_XLS_IS_LOADING](state, isLoading: boolean) {
        state.isExportXlsLoading = isLoading;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_SITE](state, value: number[]) {
        state.filterSiteIds = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_INTERVENTION_ID](state, value: string) {
        state.filterInterventionId = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_GROUPE](state, value: number[]) {
        state.filterGroupeIds = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_SOUS_GROUPE](state, value: number[]) {
        state.filterSousGroupeIds = value;
    },
    [SUIVI_INTERVENTION_PREVENTIVE.SET_FILTER_EQUIPEMENT](state, value: number[]) {
        state.filterEquipementIds = value;
    },
};
